import { Checkbox } from "@mui/material";
import { ColDef } from "ag-grid-enterprise";
import { CatalogSection } from "../../../models/CatalogSection";
import { useCatalogSectionContext } from "../CatalogSectionContext";

type Props = {};
type TableDataReturn = {
	rows: CatalogSection[];
	columns: ColDef[];
	defaultColDef: ColDef;
};

export const useTableData = ({}: Props): TableDataReturn => {
	const { state } = useCatalogSectionContext();
	const rows: CatalogSection[] =
		state.sections?.map((section) => ({
			...section,
		})) || [];

	const columns: ColDef[] = [
		{ field: "SectionName", headerName: "Name", minWidth: 20, flex: 1 },
		{
			field: "IsCircular",
			headerName: "Is Circular",
			flex: 1,
			cellRenderer: (params: any) => {
				return <Checkbox checked={params.value} disabled={true} />;
			},
			minWidth: 80,
			maxWidth: 150,
			cellStyle: {
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
			},
		},
		{
			field: "IsActive",
			headerName: "Enabled",
			flex: 1,
			cellRenderer: (params: any) => {
				return <Checkbox checked={params.value} disabled={true} />;
			},
			minWidth: 80,
			maxWidth: 150,
			cellStyle: {
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
			},
		},
		{
			field: "actions",
			headerName: "",
			flex: 1,
			minWidth: 80,
			maxWidth: 80,
			type: ["editButton"],
		},
	];

	const defaultColDef: ColDef = {
		flex: 1,
		minWidth: 100,
		sortable: true,
		filter: false,
	};

	return { rows, columns, defaultColDef };
};
